module.exports = __webpack_public_path__ + "files/adcd5cf10f5a1ab9bbba5f26cf935126.png";